/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

// =============================================
// Silver Palace Search Enhancement
//
// Behavior:
// 1. Shopify's native search runs first (title, description, etc.)
// 2. If results found → show normally
// 3. If zero results → search by SKU via suggest API and show those
//
// SKU results link directly to the matched variant.
// =============================================

(function () {

  'use strict';

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // -------------------------------------------------------
  // Search SKUs via suggest API
  // -------------------------------------------------------
  function searchBySku(query) {
    return fetch(
      '/search/suggest.json' +
      '?q=' + encodeURIComponent(query) +
      '&resources[type]=product' +
      '&resources[limit]=10' +
      '&resources[options][fields]=variants.sku' +
      '&resources[options][prefix]=last'
    )
      .then(function (r) { return r.json(); })
      .then(function (data) {
        return (
          data &&
          data.resources &&
          data.resources.results &&
          data.resources.results.products
        ) || [];
      })
      .catch(function () { return []; });
  }

  // -------------------------------------------------------
  // Fetch full product data (images, price, variants)
  // -------------------------------------------------------
  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  // -------------------------------------------------------
  // Find the variant ID that best matches the query
  // Prefers exact SKU match, falls back to contains
  // -------------------------------------------------------
  function findVariantId(variants, query) {
    var q = query.trim().toLowerCase();
    var exact = null;
    var contains = null;
    (variants || []).forEach(function (v) {
      var sku = (v.sku || '').toLowerCase();
      if (sku === q) exact = v.id;
      else if (!contains && sku.indexOf(q) !== -1) contains = v.id;
    });
    return exact || contains || null;
  }

  // -------------------------------------------------------
  // Build a product card matching Warehouse theme markup
  // -------------------------------------------------------
  function buildProductCard(product, query) {
    var image = product.images && product.images.length ? product.images[0] : null;
    var imgHtml = image
      ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy" style="width:100%;display:block;">'
      : '<div style="background:#eee;width:100%;padding-top:100%;"></div>';

    var price = (product.variants && product.variants.length)
      ? '$' + (product.variants[0].price / 100).toFixed(2)
      : '';

    var url = '/products/' + product.handle;
    var vid = findVariantId(product.variants, query);
    if (vid) url += '?variant=' + vid;

    var card = document.createElement('div');
    card.className = 'product-item product-item--vertical 1/3--tablet 1/4--lap-and-up sp-sku-result';
    card.setAttribute('data-sp-handle', product.handle);
    card.innerHTML =
      '<a href="' + url + '" class="product-item__aspect-ratio">' + imgHtml + '</a>' +
      '<div class="product-item__info">' +
        '<a href="' + url + '" class="product-item__title">' + escapeHtml(product.title) + '</a>' +
        (price ? '<div class="product-item__price">' + price + '</div>' : '') +
      '</div>';
    return card;
  }

  // -------------------------------------------------------
  // PART 1: /search results page
  // -------------------------------------------------------
  (function () {

    if (window.location.pathname !== '/search') return;

    var params = new URLSearchParams(window.location.search);
    var query = (params.get('q') || '').trim().replace(/\*$/, '');
    if (!query || query.length < 2) return;

    function run() {
      var skuContainer = document.querySelector('[data-sp-sku-grid]');

      // Only act on zero-results pages
      if (!skuContainer) return;

      var emptyState = document.querySelector('.empty-state');
      var grid = skuContainer.querySelector('.product-list.product-list--collection');
      if (!grid) return;

      // Show a loading state
      if (emptyState) emptyState.style.cssText = 'display:none!important';
      skuContainer.style.cssText = 'display:block!important';

      var loader = document.createElement('p');
      loader.style.cssText = 'padding:20px;text-align:center;color:#666;';
      loader.textContent = 'Searching by SKU...';
      grid.parentNode.insertBefore(loader, grid);

      searchBySku(query).then(function (matches) {
        if (!matches.length) {
          // No SKU matches either — show the original empty state
          if (loader.parentNode) loader.parentNode.removeChild(loader);
          skuContainer.style.cssText = 'display:none!important';
          if (emptyState) emptyState.style.cssText = 'display:block!important';
          return;
        }

        // Fetch full product data for each SKU match
        Promise.all(matches.map(function (p) {
          return fetchProduct(p.handle);
        })).then(function (products) {
          if (loader.parentNode) loader.parentNode.removeChild(loader);

          var valid = products.filter(Boolean);
          if (!valid.length) {
            skuContainer.style.cssText = 'display:none!important';
            if (emptyState) emptyState.style.cssText = 'display:block!important';
            return;
          }

          valid.forEach(function (p) {
            grid.appendChild(buildProductCard(p, query));
          });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }

  })();


  // -------------------------------------------------------
  // PART 2: Predictive search dropdown
  // Shows SKU matches at the top of the dropdown
  // -------------------------------------------------------
  (function () {

    var INPUT_SELECTOR = [
      'predictive-search input[type="search"]',
      'predictive-search input[name="q"]',
      'header input[type="search"]',
      'header input[name="q"]'
    ].join(', ');

    var debounceTimer = null;

    function buildDropdownItem(product, query) {
      var imgHtml = product.featured_image && product.featured_image.url
        ? '<img src="' + escapeHtml(product.featured_image.url) + '" alt="" width="40" height="40" style="object-fit:cover;width:40px;height:40px;flex-shrink:0;">'
        : '<div style="width:40px;height:40px;background:#eee;flex-shrink:0;"></div>';

      var price = product.price ? '$' + (product.price / 100).toFixed(2) : '';

      // Link directly to matched variant
      var url = product.url;
      if (query && product.variants) {
        var vid = findVariantId(product.variants, query);
        if (vid) url = '/products/' + product.handle + '?variant=' + vid;
      }

      var li = document.createElement('li');
      li.className = 'predictive-search__item sp-sku-dropdown-item';
      li.setAttribute('role', 'option');
      li.innerHTML =
        '<a href="' + escapeHtml(url) + '" class="predictive-search__item-link" ' +
            'style="display:flex;align-items:center;gap:10px;padding:8px 16px;text-decoration:none;color:inherit;">' +
          imgHtml +
          '<span style="flex:1;min-width:0;">' +
            '<span style="display:block;font-size:13px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' +
              escapeHtml(product.title) +
            '</span>' +
            (price ? '<span style="display:block;font-size:12px;color:#666;">' + price + '</span>' : '') +
          '</span>' +
          '<span style="font-size:10px;color:#999;flex-shrink:0;margin-left:6px;text-transform:uppercase;letter-spacing:.05em;">SKU</span>' +
        '</a>';
      return li;
    }

    function injectIntoDropdown(matches, query) {
      var predictiveEl = document.querySelector('predictive-search');
      if (!predictiveEl) return;

      // Remove previous SKU items
      predictiveEl.querySelectorAll('.sp-sku-dropdown-item').forEach(function (el) { el.remove(); });

      if (!matches.length) return;

      var list = predictiveEl.querySelector(
        'ul[role="listbox"], ul.predictive-search__list, .predictive-search__results ul'
      );
      if (!list) return;

      // Add a label
      var label = document.createElement('li');
      label.className = 'sp-sku-dropdown-item sp-sku-label';
      label.style.cssText = 'padding:6px 16px 2px;font-size:10px;text-transform:uppercase;letter-spacing:.08em;color:#999;list-style:none;';
      label.textContent = 'SKU Matches';
      list.insertBefore(label, list.firstChild);

      // Insert up to 4 SKU matches after the label
      var after = label;
      matches.slice(0, 4).forEach(function (product) {
        var item = buildDropdownItem(product, query);
        after.nextSibling
          ? list.insertBefore(item, after.nextSibling)
          : list.appendChild(item);
        after = item;
      });
    }

    function onInput(e) {
      var query = e.target.value.trim();
      clearTimeout(debounceTimer);

      if (query.length < 2) {
        var pel = document.querySelector('predictive-search');
        if (pel) pel.querySelectorAll('.sp-sku-dropdown-item').forEach(function (el) { el.remove(); });
        return;
      }

      debounceTimer = setTimeout(function () {
        searchBySku(query).then(function (matches) {
          injectIntoDropdown(matches, query);
        });
      }, 200);
    }

    function init() {
      var input = document.querySelector(INPUT_SELECTOR);
      if (!input || input._spSkuListenerAttached) return;
      input.addEventListener('input', onInput);
      input._spSkuListenerAttached = true;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

  })();

})();
